module.exports = __webpack_public_path__ + "img/img_04.9d7f5a01.webp";